export default {
  variants: {
    primary: {
      item: {
        color: 'red',
      },
    },
  },
};
